function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__c",
  x1: 444.4,
  x2: 470.9,
  y1: 592.2,
  y2: 577.1,
  gradientTransform: "matrix(-1.08448 0 0 1.26674 909.5 -414.7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__g",
  x1: 851.8,
  x2: 646.2,
  y1: 369.9,
  y2: 369.9,
  gradientTransform: "matrix(.85733 0 0 .9624 -161.5 .3)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__d",
  x1: 458.2,
  x2: 520.5,
  y1: 562.5,
  y2: 552.8,
  gradientTransform: "matrix(-1.01941 0 0 1.3554 909.5 -414.7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__e",
  x1: 472.4,
  x2: 445.3,
  y1: 578.7,
  y2: 580.2,
  gradientTransform: "matrix(1.08448 0 0 1.26674 49.7 -414.7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__f",
  x1: 518,
  x2: 456.4,
  y1: 553.7,
  y2: 558.1,
  gradientTransform: "matrix(1.01941 0 0 1.3554 49.7 -414.7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a43907"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__h",
  x1: 388.5,
  x2: 677.4,
  y1: 507.2,
  y2: 508.8,
  gradientTransform: "matrix(.88927 0 0 1.54542 50.4 -413.6)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__i",
  x1: 579.8,
  x2: 556.8,
  y1: 504.9,
  y2: 505.9,
  gradientTransform: "matrix(.91096 0 0 1.52008 49.7 -414.7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__j",
  x1: 581.4,
  x2: 558.9,
  y1: 512,
  y2: 514.3,
  gradientTransform: "matrix(-.88927 0 0 1.54542 908.8 -413.6)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__k",
  x1: 552,
  x2: 589.8,
  y1: 517.9,
  y2: 503.9,
  gradientTransform: "matrix(-.91096 0 0 1.52008 909.5 -414.7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fk_svg__b",
  x1: 444.4,
  x2: 470.9,
  y1: 592.2,
  y2: 577.1,
  gradientTransform: "matrix(.85733 0 0 .9624 -162.4 -.6)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#fk_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 0h640v480H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  fillRule: "evenodd",
  d: "M0 0h400v200H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__b)",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeWidth: 10,
  d: "M412.9 308.9a11.3 12.7 0 00-1.7 0c-3 .6-7.6 11.3-10 17.6-4.1 5.4-6.2 9.6-7.8 12.7-.7 1.2-1.7 2.6-1.4 4.2-6 1.6-6.3 7.4-6.3 9.6 0 2.5.7 3.7.7 3.7l3.6 7.5v.1c3.8 9 9.4 20.9 12.7 21.8 4.4 1.5 16-3.3 24.8-11.7a140.6 157.8 0 0053.2 12.1c20.4 0 38.7-5.5 53-12.1 8.8 8.4 20.4 13.2 25 11.7 3-1 8.7-13 12.6-21.8l3.5-7.6s.7-1.2.7-3.6c0-2.2-.3-8-6.3-9.6.3-1.6-.6-3-1.3-4.3-1.7-3.2-3.8-7.4-7.7-13-2.6-6.2-7.2-16.7-10-17.2-4.2-.8-13 1.5-13 2.4v.4l-17.7 18.6c0 .5.9 14 4.3 26a126 141.5 0 01-43.3 8.2c-17 0-31.5-3.4-43.2-8.3a116.6 130.9 0 004.3-26L424 311.8v-.4c0-.7-6.8-2.5-11.1-2.5zm4.4 23c2.3 0 4.6 2.2 6.5 4.4l-.1 1.3a67.5 75.7 0 01-2.8 10.2 73.6 82.6 0 01-12.2-9.9c1.9-2.3 5-5.4 8.2-5.8h.4zm126.6 0h.4c3.3.6 6.3 3.7 8.3 6a73.4 82.4 0 01-12.3 10 67.1 75.4 0 01-2.8-10.3 14.6 16.4 0 01-.2-1.3c2-2.3 4.3-4.3 6.6-4.3zm-142.4 26.4c2.4 2 5.4 4.4 9.1 6.8a10.5 11.8 0 01-3.2 1.6c-1.6.4-3.1.3-4.7 0a15 16.8 0 01-1-5.6 60.3 67.7 0 01-.2-2.8zm158.2 0l-.1 2.8a15 17 0 01-1 5.5 10.3 11.5 0 01-8-1.5c3.7-2.4 6.8-4.8 9.1-6.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__c)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M426.2 339.6s-6.1-11.1-11.1-10.2c-5.1.7-10 7.8-10.2 8.2a44.5 52 0 01-7.5-9.5c.3-.4 7.8-20.9 12-21.8 4-.9 12.7 1.5 12.7 2.3z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__d)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M439.8 327.7c0 .8-2.2 30.2-10.9 40.4-8.6 10.3-23 16.6-28.2 15.1-5-1.6-16.5-31.3-16.5-31.3s12.2 14.2 21.3 11.8c9.1-2.3 14.6-20.1 16.3-28.9 1.7-8.6.3-25.7.3-25.7l17.8 18.6z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__e)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M532.9 339.6s6.2-11.1 11.2-10.2c5 .7 9.8 7.8 10.2 8.2a44.5 52 0 007.5-9.5c-.4-.4-7.9-20.9-12-21.8-4.1-.9-12.8 1.5-12.8 2.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__f)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M519.3 327.7c0 .8 2.2 30.2 10.9 40.4 8.7 10.3 23 16.6 28.2 15.1 5-1.6 16.6-31.3 16.6-31.3s-12.3 14.2-21.4 11.8c-9-2.3-14.5-20.1-16.2-28.9-1.8-8.6-.4-25.7-.4-25.7l-17.8 18.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__g)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M401.2 326.2c-4 5.5-6.1 9.8-7.9 13-1.7 3.2-.6 7.7 3.2 14 4.3 6.7 39 33.4 84.1 33.4 45.2 0 79.8-26.6 84-33.4 4-6.4 5-10.8 3.3-14-1.7-3.2-3.9-7.5-7.9-13 0 8.3-28.7 38.5-79.4 38.5s-79.4-30.2-79.4-38.5z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__h)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M557.7 378.8l7.8-15.1-3.9-3.2c-1 3.8-5.5 5.1-6.3 10-.7 4.7 3 9.4 2.4 8.3z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__i)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M564.8 374.5s1.4-6.8-3-7.6c-4.4-.8-6.8 3.8-6.1 2 .6-2 3.2-4 3.7-10.7.3-6.7-.4-10.3-.4-10.3s1.8-8.7 8.8-7.5c7.2 1.3 7.5 7.6 7.5 9.9a9 9 0 01-.6 3.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M539.2 351.7l1.5 2.8 1-.6-.7-2 .1-.3 1.7-1.2 4.4 8.7v.5l-1 .7.5.8 4.2-3-.4-.8-1 .6h-.3l-4.4-8.8 1.6-1.2h.4l1 1.6 1-.7-1.5-2.8-8 5.7zm-10.5 6.7l.4.8.9-.4.3.1 3.9 8.9-.1.4-.8.6.3.8 4.1-2.5-.3-.8-.9.4h-.4l-1.8-4.3 4.3-2.4 1.8 4v.5l-1 .6.4.9 4.2-2.5-.4-.8-.9.4-.3-.2-3.8-8.8v-.4l.8-.6-.3-.8-4.1 2.5.3.8 1-.5.3.2 1.5 3.6-4.2 2.5-1.6-3.7.2-.4.8-.5-.4-.9zm-2.4 7.6l.2.8 1.2-.3.4.1.9 3.7-.8.4c-2.5.8-4.4-.5-5.3-3.7-.8-3.2.2-5.6 2.5-6.4a3.5 4 0 011.4-.1l.3.2.8 1.7 1.2-.4-.7-3c-1.3 0-2.5.2-3.5.6-3.6 1.3-5.2 4.5-4.3 8.2 1 3.7 3.9 5.4 7.2 4.3a11.3 12.7 0 003.4-2L530 366l.2-.4.9-.4-.3-.9zm-9.7 10.3l4.7-1.7-.3-.9-1 .2-.3-.1-2.6-9.6.1-.3 1-.5-.2-.8-4.7 1.6.3.9 1-.3.4.2 2.5 9.5-.2.4-1 .4.3.9zm-25.5 4.6l8.3-.8-.3-3.4-1 .1-.2 2-.2.3-3.5.4-.4-4.9 2-.2.3.3.2 1.3h1l-.4-4.4h-1v1.4l-.2.4-2 .1-.4-4.4 3.1-.3.2.2.4 1.7 1.1-.1-.2-3-7.8.8v.9h1l.3.3.7 9.9-.1.3-1 .2v1zm-12.4-12.3v1h1l.2.3.1 9.9-.2.3-.9.2v.8h4.4v-.9h-1l-.2-.4V375h4.4v4.6l-.2.3-.9.1v1h4.4v-1h-1l-.1-.4-.2-10 .2-.3h1v-1h-4.5v1l1 .1.2.3v4l-4.3.1-.2-4 .3-.3h.9v-1zm-9.4-.3v3.3h1l.3-2 .2-.3h1.9v10.2l-.3.4h-1v1h4.6v-.9l-1-.1-.3-.4.1-10h1.8l.3.2.3 2h1v-3.3zM455 378.9l8 .4.2-3.3h-1l-.3 1.9-.2.2-3.5-.1.2-5 1.9.2.2.3.2 1.4h.8l.2-4.3h-.9l-.2 1.2-.2.3h-2l.2-4.6 3 .2.2.2.1 1.7h1.1v-2.9l-7.5-.4v.9l1 .2.1.3-.4 9.9-.2.3h-1v.9zm-18.6-5.4l4.4 1.6.2-.8-1-.5v-.4l2.5-9.5.3-.2 1 .3.2-.8-4.3-1.7-.2.9.9.4.2.4-2.7 9.4-.2.3-1-.3zm-7.6-3.3a8.4 9.4 0 002.6 1.6c2.4.8 4.3-.2 4.8-2.2a3 3.5 0 00-.5-3.2l-1.8-2c-.6-.9-.8-1.6-.6-2.5.3-.9 1.1-1.4 2.2-1 .4.2.8.4 1 .7v.3l-.2 2 1 .3.8-2.8a8 9 0 00-2.5-1.7c-2-.8-3.8.3-4.4 2.2a3.2 3.5 0 00.4 2.8c.4 1 1 1.5 1.5 2 .9 1 1.2 2 1 2.9-.3 1-1.2 1.5-2.4 1a4 4.5 0 01-1.2-.8l-.1-.3.4-2.2-1.1-.4zm-9.8-4.6l7.4 4 1.2-3-1-.5-.9 1.7-.3.1-3.1-1.8 1.8-4.3 1.8 1v.3l-.3 1.3.8.5 1.6-4-.8-.4-.7 1.1-.3.2-1.7-1 1.6-4 2.7 1.5.1.3-.4 1.6 1 .5 1-2.6-6.8-3.9-.4.8.8.6.1.4-3.6 9h-.3l-.9-.3zm-1.1-15l-3.7-2.9-.5.8.7.7.1.4-4.6 8.2-.4.1-.7-.5-.5.8 3.6 2.8c1.4 1 2.5 1.5 3.6 1.4 1.6-.2 3-1.2 4-3 1.8-3.4 1.3-6.6-1.6-8.8zm-1.6 0l.8.6c2 1.5 2.2 3.7.5 6.6-1.7 3-3.5 3.6-5.4 2l-.8-.4 5-8.7zm29.3 13l-.1.8.9.3.1.4-1.7 9.7-.3.2h-1v.8l4.1 1 .2-.8-1-.4-.1-.3.7-4.1h.3c1.5.4 1.8 1.3 1.8 3.2.1.9.1 1.7.8 2.7.3.4.7.8 1.4.9a10.1 11.4 0 001.5.2l.1-.8h-.1c-1-.3-1.5-.7-1.5-1.8-.2-1 0-2-.4-3a2.6 2.9 0 00-1.3-1.4c1.7 0 2.7-.9 3-2.5.4-2-.5-3.5-2.9-4l-4.4-1.1zm3 1.7l.6.2c1.4.4 2 1.4 1.7 2.9-.3 1.7-1.2 2.3-2.8 1.8l-.5-.1.9-4.8zm54.2 1l.1 1h1l.3.2 1.4 9.8-.2.3-1 .3.2.8 4.5-.8v-1l-1.1.2-.3-.3-.6-4h.3c1.6-.5 2.2.2 3 1.9.3.8.5 1.6 1.5 2.2.4.3 1 .4 1.8.3a12 13.6 0 001.6-.5l-.1-.9h-.2c-1.1.3-1.7 0-2.2-.9-.4-.8-.7-1.8-1.3-2.5-.4-.5-1-.8-1.8-.8 1.7-.8 2.5-2 2.3-3.7-.3-2-1.7-3-4.2-2.5zm3.5.5h.7c1.6-.4 2.5.2 2.8 1.8.2 1.6-.5 2.6-2.2 3h-.6l-.8-4.8z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__j)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M401.5 378.8l-7.8-15.1 3.9-3.2c1 3.8 5.5 5.1 6.3 10 .7 4.7-3 9.4-2.4 8.3z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#fk_svg__k)",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.2,
  d: "M394.3 374.5s-1.4-6.8 3-7.6c4.4-.8 6.8 3.8 6.2 2-.7-2-3.3-4-3.7-10.7-.4-6.7.3-10.3.3-10.3s-1.7-8.7-8.8-7.5c-7.1 1.3-7.5 7.6-7.5 9.9 0 2.2.7 3.5.7 3.5z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#0072c4",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeWidth: 3.9,
  d: "M480.5 356.1s-82-27-81.4-129.4l.6-135.6H561l.6 134.8c.5 102.4-81.4 130.1-81.4 130.1z"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#bcbcbc",
  d: "M410.262 123.61c.146 0 1.099-1.07 2.051-1.974 1.246-.822 2.419-1.727 3.664-2.468 1.026-.575 2.931-1.069 3.737-1.562a9.16 10.282 0 003.078-2.797c.146-1.728.366-3.044.366-5.1 1.32-.823 2.492-1.48 3.664-1.974 1.685-.576 2.052-1.316 3.737-1.645 1.1-.412 2.858-.412 4.397-.412 1.685 0 2.711 1.399 4.25 1.646 1.832.822 2.638 1.398 4.103 2.796.733 1.152 1.246 2.139 2.638 2.961 1.1.659 2.125 1.646 3.37 1.975 1.466.904 2.639 1.48 3.738 2.796 1.026.823 1.465 1.974 2.345 2.797a26.453 29.694 0 003.444 2.797c1.465 1.07 2.93 1.892 5.202 1.645 1.246 0 2.565-.247 4.03 0 1.686 0 3.298 0 4.763.493 1.76 0 3.151.247 4.763.412 1.466.246 3.005.329 4.69.329 1.466.493 3.078.411 4.763.411h9.526c1.685 0 3.444.082 4.69.411a37.37 41.95 0 004.762-.411c1.832 0 3.225-.33 5.057-.411h5.715c1.466.493 3.37.822 4.397 1.645 1.392.411 2.051 1.151 3.37 1.563 1.1.575 2.638 1.563 3.444 2.796a18.1 20.317 0 012.711 4.36c.88 1.48 1.246 3.29 1.979 5.182.44 1.81.733 3.537.733 5.511.366 1.728.293 3.62.293 5.594-.367 1.81-.44 3.783-1.026 5.51 0 1.975-.366 3.702-.66 5.183-.293 1.645-.659 2.714-.732 4.77v5.594c0 1.81-.44 3.126-.587 5.1a52.026 58.402 0 00-2.418 6.005 10.772 12.092 0 00-2.71 3.125c-.734.494-1.1 1.317-.953 1.646 1.319.493.952 1.562.952 3.537.22 1.562.367 3.454.733 5.182.073 1.892.44 3.043.953 4.36.586.822.732.41-.66.41-.953.823-1.978.412-2.345-1.233a8.793 9.87 0 01-1.392-4.36c-.147-1.81-.44-3.62-.953-4.77-.22-2.222-.732-2.222-2.71-2.386-.953-.905-2.2-1.152-4.104-1.152-1.832 0-1.979-.246-1.979 1.974v5.594c-.366 1.645-1.026 2.879-1.392 4.36-1.026.822-1.466 2.22-2.711 3.125-.586 1.81-1.392 2.139-3.005 2.468l-2.051-2.797c.952-1.81 1.758-2.056 2.345-4.03.732-1.563 1.172-2.55 1.685-3.949-.733-1.234-1.319-1.81-1.979-3.537a19.272 21.633 0 01-1.685-4.36c-1.172-.493-2.93-.575-3.737-1.233-1.685-.411-2.125 1.645-4.103 1.645h-4.69c-2.125 0-2.638 1.234-4.397 1.152-.513.164-1.832-.083-3.737 0-1.465.575-3.15.41-4.763.41-1.685 0-3.077-.493-4.396-.822-1.539-.493-3.078-.987-4.69-1.151-1.978 0-2.784.164-4.103 1.151-1.026.74-2.565 2.303-3.664 3.208-.513 1.316-.733 3.537-1.466 5.1-.293 1.645-.879 2.55-1.245 4.03a13.483 15.135 0 00-1.026 4.772c-.147 2.632-.66 2.303-2.052 1.562-.586-1.151-1.465-2.303-2.052-3.619.293-1.974.733-2.961.733-5.1-.366-1.645-1.099-1.48-2.052-.411 0 2.056 0 3.702-.732 4.77a4.397 4.935 0 01-1.979 3.127c-.513 1.48-1.612 2.22-2.711 2.796-.147 0 0-.493 0-1.645-.806-1.727 0-3.29 0-5.511 0-1.974-.147-3.29.366-5.1 0-1.974-.732-3.784-1.026-5.182-.659-1.48-1.025-2.22-2.71-2.797-1.246-.575-2.932-1.234-3.738-2.467a7.034 7.897 0 00-3.077-2.715c-1.466-.576-2.272-1.234-3.371-1.974-1.026-1.316-1.905-1.81-2.345-3.537-.733-1.234-.806-3.537-1.319-5.182a15.9 17.85 0 00-1.026-4.771 17.806 19.988 0 00-1.026-4.77c-.22-1.646-.586-3.291-1.025-5.183 0-1.892 0-3.784-.367-5.511v-5.593c-.22-1.646-.293-3.949-.66-5.183 0-2.138-.22-3.29-.732-4.77-.733-1.399-.733-1.975-1.979-2.386-.879 1.234-2.271 1.81-4.03 2.057-1.245-.33-3.004-.576-4.396-1.234-1.393-.33-2.272-.987-3.371-1.645a31.655 35.535 0 00-2.052-3.126c-.22-2.057-.586-3.126-.732-5.182 0-1.48.073-.658 1.465-2.715z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fefefe",
  d: "M430.266 137.923l.293-.33c-.586.659-.366.33.953-.246.733-.494 2.125-1.398 2.638-1.974.586-.33 1.612-.823 2.198-1.399.586-.822 1.246-1.48 2.125-2.22.88-.905 1.759-1.234 2.858-1.975 1.319-.164 1.832-.822 3.077-.329 1.173.33 1.686.33 2.638-.822.953-.658 2.052-1.398 2.418-2.468v-1.727c0 1.81-.366 2.467-1.465 3.043-.733 1.07-1.759 2.139-2.198 3.126-.733 1.234-.88 1.892-1.612 2.468-.66.904-1.686 1.398-1.906 2.879.293.658 0 .987.733 1.069.66.658 1.392.411 2.345 0a10.405 11.68 0 001.905-3.29c.806-1.316 1.246-1.892 1.685-2.88.88-.657 1.393-1.15 1.686-2.22.952-.658 1.758-1.316 2.418-1.974.733-.494 1.1-.905 2.125-1.152a4.397 4.935 0 01-.733 3.126c-.22 1.563-.146 2.303.293 3.29.66.576.513.987.953 2.056.366-.987.586-2.796.733-3.948v-.247c0 1.152 0 2.797-.293 3.62 0 1.645.366 2.385.732 3.619.367.658.733 1.07 1.173 1.398 0-1.645.44-2.632.513-4.112.293 1.069.22 2.632.44 3.866.073 1.316.512 2.303.952 3.372.586.33.733 1.48.952.576.587-1.974.587-4.113.953-6.17.073-1.069.147-2.632.513-3.372l-.513 3.29c.073-.987.147-2.467.513-3.29v-.329a28.578 32.08 0 01.513 4.524c0 1.234-.073 2.468.22 3.62.733-.412 1.245-1.399 1.685-2.468a13.336 14.97 0 011.905-3.126l-1.905 3.044a13.336 14.97 0 011.905-3.044v-.247a29.53 33.15 0 00-.22 3.866c0 1.316 0 2.797.22 3.702.293 1.48.66 1.727.733 3.29 0 .823-.147 1.645.22 2.056 1.026.247 1.026-.41 1.172-1.974 0-1.81.44-3.043.513-4.77 0-2.14.22.246.44 1.069a9.526 10.693 0 01.733 3.701c0 .823-.074 1.563.22 1.974.952-.493 1.318-1.645 1.905-2.303.513-1.316 1.025-1.892 1.465-2.796 1.246-.247 1.173-.823 1.173-2.468 0-1.398-.074-2.797.293-3.948a30.043 33.725 0 00.952-3.702c.44-.247.88.494 1.173 1.152.513.905.44 2.22.44 3.619.292 1.234.732 2.22 1.245 3.372a10.991 12.338 0 001.685 2.797c.22.905.22 2.468.22 3.702.953-1.234 1.1-2.962 1.173-4.771-.147-1.234-.147-2.797-.44-3.948 0-1.234-.293-2.468-.513-3.373-.733-.411-.953-.823-.22-1.974.733-.74 1.612-.411 2.858-.247.66.74.88 1.152.953 2.797 0 1.48 0 2.632.512 3.62.44.822.88 1.397 1.173 2.796.366.411.66.987 1.172.329.293-.823.513-2.468.733-3.373.22-1.069.66-1.645 1.172-1.974 0 1.563 0 2.468.513 3.62.44 1.233.733 1.727 1.173 3.125.513.411.586 1.234 1.246 1.645.146-1.316.22-2.796.22-4.442v-3.948c.073-1.316.366-2.056.732-3.126.733 1.152.733 1.563.733 3.126.733-.329.88-.987 1.172-1.974.513-.576.733-.823.953.576.146 1.48.44 2.797.733 4.195.44.658 1.025 2.22 1.612 2.797a12.017 13.49 0 001.465 2.303c.367.822.44 1.398 1.466 1.645 0-1.892 0-3.784-.293-5.594 0-1.645-.293-2.22-.44-3.701-.44-.905-.66-2.385-.513-2.797a8.06 9.048 0 012.198 3.373c.513 1.398 1.026 2.303 1.466 3.701a14.655 16.451 0 011.832 2.797c.88.823 1.319 1.727 2.198 2.468.44.493 1.466.822 1.685.575-.073-1.645-.293-3.043-.732-4.441a6.595 7.403 0 00-.733-3.373c-.953-.905-1.685-1.563-2.198-2.797-.294-.41-.367-.658-.44-1.398a19.272 21.633 0 013.37 3.866 5.13 5.758 0 001.906 1.974c.44.658 1.832 1.399 2.858 1.645a4.103 4.606 0 002.418 1.728l-2.418-1.645a4.103 4.606 0 002.418 1.645v.329a9.526 10.693 0 00-1.466-4.524 6.448 7.239 0 00-2.198-3.126 6.815 7.65 0 00-2.345-2.468c-.66-.822-1.612-2.303-2.198-2.796 1.099-.823 2.271.493 3.37 1.069.953 1.151 1.832 2.632 2.419 3.372a13.19 14.806 0 002.198 3.702c1.026.658 1.685 1.316 2.565 2.22 1.465.412.879-.164.512-1.398-.512-1.645 0-1.645.953-.575.66.575 1.466 1.398 2.418 1.974.367.576 1.026.987 1.612.576.293-.412.293-.412.293-.823-.513-1.81-.952-3.126-2.198-3.701-.513-.823-1.465-1.646-2.198-2.468-.44-.823-.953-1.316-1.392-2.303l1.465 2.22c-.513-.822-1.026-1.233-1.465-2.22h-.22c1.465 0 1.978.493 3.077 1.151a4.983 5.593 0 012.199 1.974c.44.658 1.172 1.399 1.685 2.221l2.345 1.974c.806 1.152.952 1.892.952 3.62.513.822.587 2.467.733 3.372-.146 1.563-.66.33-.733-.576-.146-1.233-.586-1.151-1.465-.822 0 1.645.22 2.139.733 3.372a5.862 6.58 0 01-.88 2.797c-.586.411-.733-.822-1.245-1.398 0-1.645-.44-1.892-1.466-2.797v1.152c.586 1.151 1.172 2.22 1.246 3.866a8.793 9.87 0 01.513 3.701c0 1.399 0 2.715-.293 3.948 0 1.481-.22 2.14-.22 3.62v7.896a17.073 19.166 0 00-.22 3.62l.22-3.62c-.22.987-.22 2.221-.22 3.62v.246c-.44-1.398-.953-2.632-1.246-4.112a7.547 8.472 0 01-1.612-2.88c-.22-1.233-.293-2.632-.513-3.619-.366-.987-.733-2.056-1.465-1.398-.293 2.056.073 3.29.732 5.264.367 1.316.367 2.468.733 3.702.586 1.48 1.026 1.645 0 3.29-.513.987-.733 1.234-.952 2.303-.88.494-1.1.823-1.173 1.974-.293-1.069-1.026-2.385-1.465-3.619-.44-1.398-.953-2.797-1.173-3.948-.586-.987-1.319-2.468-1.905-3.126-.66-.822-1.465-2.468-1.905-3.29-.953-1.234-1.173-1.974-1.979-2.55-.146-.576-.44-1.316-.952-.823 0 1.316 0 2.715.293 3.866.22 1.646.66 2.55.733 4.195v3.126c-.586-1.645-1.246-2.961-1.686-4.524-.586-.822-1.099-2.468-1.685-3.043-.44-1.152-.733-2.057-1.246-2.797-.073-.823-.44-.823-.732-1.398 0 1.562.513 2.138.732 3.29.513 1.151.66 2.879.513 3.455-.586-1.975-1.172-4.113-1.905-5.923-.733-1.151-1.465-2.632-1.905-3.701-.733-.905-1.466-.987-2.198-1.645a4.323 4.853 0 01-1.686-1.399c.22 1.48.733 2.468.953 3.62.22 1.398.733 2.55.952 3.701-.22 1.892-.586-.576-.952-1.398-.22-1.646-.733-2.468-1.173-3.373-.659-.576-1.245-1.48-1.905-1.974-.732-.33-.44 0-.44 1.07 0 1.727 0 2.878.44 3.948.513.822.513 1.891.513 3.372-.073 1.398-.293 2.468-.293 3.948v2.221c-.513-1.151-1.026-1.892-1.465-3.372-.733-1.316-1.026-2.221-1.612-3.62-.513-.246-1.466-.493-1.906 0 .074 1.399.66 1.975.733 3.62-.952 1.07-.806 1.398-1.465-.247-.513-1.316-1.173-1.234-1.906-1.974-1.245-.165-.806-1.07-1.172-2.303 0-1.07 0-2.139-.293-3.044-1.32 0-2.052 0-2.858.823-.366.822-.22 2.467 0 3.701v3.866c-.293.987-.733 1.07-.952 2.304-.44 1.151-.587 2.467-.953 3.29-.88.905-.513.987-.953-.494v-9.048c0-1.48.22-2.22.22-3.62-.513-1.15-.586-1.398-2.198-1.398-.293.74-.147 2.057 0 2.797 0 1.398.146 2.715.293 3.702 0 1.48.147 2.385.22 3.619 0 1.48-.293 2.632-.953 3.29-.806.33-.073.987-.952 1.234a10.991 12.338 0 01-2.638-1.974c-.88-.33-1.759-.576-3.078-.576-1.612 0-1.612-.247-2.198-1.645a23.009 25.828 0 01-.953-4.524c-.513-1.316-.586-2.221-.952-3.702a4.543 5.1 0 00-1.466-1.974c-.293 1.48-.586 2.632-.66 4.278-.292.658-.366 2.303-.512 3.043-.44-.823-.66-2.468-.953-3.62-.44-1.644-.806-2.796-2.345-2.22-1.612 0-1.685 0-1.685 1.974l1.905 3.29v3.948c0 1.646.073 2.14-.952 2.468-.367-1.645-1.246-3.29-2.199-4.688-.073-1.152-.366-.823-1.392-.823-.66 0-1.319-.164-1.685.247v2.467c-.587.165-.733 0-1.173-.493-.44.822-.146 1.974 0 3.043-.293 1.316-.732 2.468-1.172 3.126-.147-.411-.367-.247 0-.247-1.685-.74-2.931-1.151-4.397-1.645-.732 0-1.392.905-1.832 1.645-1.245.412-1.758.823-3.15.823-1.32 0-1.906.247-3.078.247-.88.246-1.979.329-3.15.329-.587-.247-1.76-.247-2.126-.576.513-.823 1.026-1.234 1.466-2.468a14.655 16.451 0 001.905-2.056c.586-.494 1.319-1.563 1.905-2.221.366-1.398.88-1.645 1.685-2.221 1.466 0 1.686.576 3.078.823 1.392.575 2.198.822 2.93-.33 1.1-.493 2.053-1.398 3.298-1.645l2.418-1.645c1.026-.74 1.466-1.48 2.345-2.303.293-1.151 1.026-2.056.733-3.29-1.319-.411-2.125-.33-2.931.493-.953.988-1.172 1.399-2.345 2.221-.952.33-1.465.823-2.638 1.152-.952.411-2.198.247-3.297.247s-2.492-.083-3.151.329c1.1-.823 2.345-1.645 3.37-1.974.953-.74 1.32-1.07 2.639-1.152.586-.823 1.172-.823 1.465-2.22.366-1.646-.952-1.152-1.978-.577-.953.247-2.052.987-2.858 1.399a10.478 11.763 0 01-3.078.575c-.293-.493.22-.904.44-1.645 1.1-.493 1.319-.658 1.465-1.974-1.318.165-1.758.658-2.93.823-1.173.329-2.419.493-3.81.576h-3.298c-1.173 0-1.832-.33-3.151-.33-.953-.575-.953-.822-.953-2.467.733-.987 1.466-.823 2.931-.823l2.565-1.48c.88-.165 1.465-.576 1.246-1.07h-3.371c-1.32-.658 0-.904.733-1.398 1.099 0 2.344 0 3.077.494 1.466 0 1.979-.576 3.078-1.646.952-.822 1.465-1.398 2.418-1.974.733-.905 1.465-1.398 1.905-2.22 1.026-1.07 1.685-1.646 2.198-2.55.587-.412 1.026-.823.733-1.399-1.539.165-2.198.823-3.15 1.645a7.328 8.226 0 01-1.906 1.645 6.009 6.745 0 01-3.15 1.234c-1.173 0-2.199-.247-3.298-.329-1.32-.164-.147-.493.22-1.151.513-.33.879-1.234.44-1.892-.953-.412-2.199-.33-3.298-.33h-3.37c-1.246 0-1.76-.328-2.639-.822-.22-.823 0-.576.953-.576a13.19 14.806 0 003.15-.576c1.1-.329 1.246-.822 1.466-2.22-1.172 0-2.418 0-3.15-.247zm-20.664-6.416c-.22-2.057-.66-3.126-.732-5.182 0-1.48.073-.658 1.392-2.715.146 0 1.099-1.07 2.051-1.974 1.246-.822 2.419-1.727 3.664-2.468.953-.575 2.931-1.069 3.737-1.562a9.16 10.282 0 003.078-2.797c.073-1.728.293-3.044.293-5.1 1.392-.823 2.565-1.48 3.737-1.974 1.685-.576 2.052-1.316 3.737-1.645 1.1-.412 2.858-.412 4.397-.412 1.685 0 2.711 1.399 4.25 1.646 1.832.822 2.638 1.398 4.03 2.796.806 1.152 1.319 2.139 2.711 2.961 1.1.659 2.125 1.646 3.37 1.975 0 1.48.294 1.233-.585 1.233-.147 1.481-.44 1.317-1.686 1.399a5.862 6.58 0 01-2.198-2.303c.513-1.399.22 1.233 0 1.727-.586.576-.953 1.152-1.612.576-.44-1.399-.733-2.303-.733-3.948-.22-1.728-.66-.494-.952.246-.367 1.48-.22 1.974.22 3.126-1.246 0-2.199-.164-3.078-.329-.88-.247-1.905.082-2.931.576-1.246.905-.806.905-.22 1.974 1.1.411 1.905 1.07 2.931 1.645 1.026-.164 2.198-.493 3.297-.823 1.173-.41 2.199-.164 3.371 0 .586.412 1.32.412 1.685.823 0 .905 0 1.81-.293 2.303-.44.411-.952 1.399-1.685 1.645a11.797 13.243 0 01-3.297 1.48c-1.466 0-2.052.412-3.151 1.07-.147 1.48-.513 1.81-1.686 2.303a7.547 8.472 0 01-3.297.823c-.733 0-1.392.082-1.685-.329a9.38 10.529 0 001.905-3.29c.22-.658.66-.987.22-1.48-1.393.081-1.759.081-1.906 1.644-.146 1.563-.659 1.81-1.685 2.303.293-1.398.366-2.467.733-3.619a18.319 20.564 0 01-3.078.247c-.732.493-1.026.74-.732 1.645-.953.411-2.199.165-3.371 0-1.026 0-.44-.493-1.173-1.07-.513-1.069-1.025-1.315-2.198-1.398-.513.823-1.465 1.07-2.125 1.645-1.026.412-1.685.083-2.638-.493-1.172 0-1.026.411-.733 1.398.513.33 0 .74.733.823.733.658 1.32.822 2.638.822 1.026-.329 2.198-.246 3.37-.246 1.173 0 .953.329.953 1.645-.732.658-1.905.576-3.15.576a12.164 13.654 0 01-2.858-.823c-1.1-.082-1.979-.329-2.858 0-.366.494-1.466.658-.22.823.513.575 3.298.246 3.444 1.233.733.823.513 1.892-.586 1.892a1.612 1.81 0 00-1.685 0c-.733.165-1.759 0-3.151.165 1.832.164-1.32-2.221-1.979-3.208z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bcbcbc",
  d: "M417.15 122.212l-1.466 1.07c-1.026.657-2.198 1.644-2.858 2.22-.513.494-.513.823-1.172.823 1.1-.165 1.612-.494 2.638-1.07 1.246-.164 2.418-.493 3.078-1.151.659-.247 0-1.316-.22-1.974zm10.991-13.243c.147 0 .44.822.953 1.398.366 1.07.732 1.81.732 3.126.294-1.399.733-2.468.953-3.949-.366-.822-.366-1.069-1.465-1.151 0 .822.146.247-1.173.576z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c4c4c2",
  stroke: "#000",
  strokeWidth: 0.9,
  d: "M349.4 417.7c-.5 0 .8-.5 1.3-.6.4-.8.6-1.3 1.3-1.8 1.1 0 1.7.4 2.2 1.1 1 .3 1.3.7 2.4.9.5.4 1 .4 0 .7-.6.3-1.5.4-2.6.4a7.2 7.2 0 00-2.6.7c-1.5 0-1.3 0-2-1.4z",
  transform: "matrix(1.08448 0 0 1.26674 42.563 -410.231)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bcbcbc",
  d: "M432.464 109.215v.33c0-.823 0-.412.22 1.151a6.595 7.403 0 01.513 3.29 4.91 5.511 0 001.466-2.467c0-2.221-.367-2.139-2.199-2.304zm8.793 32.327h.294c-.733 0-.294 0 .952-.823.806-.658 1.466-1.645 2.638-1.974a9.526 10.693 0 013.078-1.974c.586-.329 1.099-.822 1.685-.247-.146 1.317-.366 1.892-1.465 2.468-.513.823-1.32 1.316-2.125 1.645-.733.494-1.613.494-1.906 1.48-1.319.659-1.465.494-3.077-.575zm4.617 8.143c.366-.41 1.905-2.138 2.638-2.796a10.991 12.338 0 012.345-2.797c.732-1.234 1.612-2.056 2.198-3.126l1.905-2.796c0 1.233-.146 2.879.22 3.619a5.13 5.758 0 01-.733 3.372c-.513.987-.952 1.645-2.198 2.303-1.026.659-1.685.823-2.565 1.646a19.052 21.387 0 01-2.198 1.398c-.66.329-.366.247-1.612-.823zm-7.474 6.416h.293c-.733 0-.367.083.952-.822 1.026-1.152 1.832-1.645 3.078-2.221a7.547 8.472 0 002.931-.823c.513-.164.953-.575 1.392 0 .733 1.152.953 1.48-.22 2.221a6.888 7.732 0 01-2.418 1.399c-.586.575-1.758.575-2.93.822-.88 0-1.466.165-1.833-.576l1.906.576c-.953 0-1.466.165-3.151-.576zm10.258 0v-.246c0 .822 0 .41.513-1.152.953-1.563 1.246-2.468 2.418-2.797.513-.822 1.466-.987 2.638-1.398.44.823.074 1.81 0 2.797-.293 1.069-1.172 1.81-1.685 2.55-.733.575-1.026 1.151-2.198 1.398-.88 0-.367 0-1.612-1.152z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.283 119.662c0 .74-.513 1.398-1.172 1.398-.733 0-1.246-.658-1.246-1.398 0-.74.586-1.398 1.246-1.398s1.172.575 1.172 1.398z"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  fill: "#005120",
  fillRule: "evenodd",
  stroke: "#002b0d",
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  d: "M351.8 479.6h.9c-2.8 0-1.1-.2 3.5 3.5 2-1.6 2-1.8 3.5 1 1 1.5 1.2-.2 2.7-1.8.7 3.2 1.1 6.5 3.5 3.5 2.8 0 5.6-.2 7.1.9 1.8 3.3 1.2-.6 2.6.9 4 .4 3.9-3.4 8.1-4.4 2.6 3.3 3.8.8 7-.8 2.5.6 4.8 4.3 5.3.7 2-3.2 2.1-3 3.5 0 2 1.8 2.8-.8 4.4-1.7 3 1.7 6.3 2 10.6.9.8 2.9 2.6 1.6 4.5.8 3.9 1.7 5.2 2.2 9.7 0 2.2-2.6 1 .1 2.6 1.8 3.3-1 2.4-1.2 6.2-.9 3.9 0 4.2 0 5.3-2.6 2 1.9 2.6 3.3 5.3.9 4.2 0 2.9.5 5.3-1 1.9 4 2.3 1.2 4.5 2.7a14.5 14.5 0 01-6.2 7c-1.7 3-2.8 6-6.2 7.2-2.5 2.5-5.2 4-8 6.2-3.8 1-8 .8-12.3.8H388c-2.6 1.4-7 2-10.6 2.7-4 0-8.7 0-11.5-.9-1.9-1.9-5.2-4-7-6.2-2-1.5-2-4.4-3.6-6.2-1.4-2.5-2-6.5-3.5-8.8z",
  transform: "matrix(1.08448 0 0 1.26674 47.326 -411.383)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M437.5 487.6v.8c0-2.4.1-1.1-1.8 3.6-.3 1.1-1.2 1.4-2.6 1.8m-3.5-2.7h.9c-3.3 3-5.5 4.5-6.2 8l6.2-8c-3.3 3-5.5 4.5-6.2 8m-7.1-12.4s-.1 3.1-.9 4.4m-2.6 1.8v.8zm-7.1-5.3h.9-1c.4 0 .7 0 0 0zm-49.5 0c.4 0 2.2 2.8 4.4 4.4-.5 2.6-1.4 5.6 0 8m2.7-7.1c.4 0 2.1 2.8 4.4 4.4l-4.4-4.4c.4 0 2.1 2.8 4.4 4.4v.9c0-2.8-.2-5.6.9-7.1 1 1.7 2.2 4.3 2.6 1.8 5-.2 7.4-1.6 10.6-2.7 0 1.3-.2.7 1 1.8m60-3.6h.9c-1.7 1.4-3 4.3-4.4 6.2m-32.7-8.8h7",
  transform: "matrix(1.08448 0 0 1.26674 47.326 -411.383)"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M425.9 214.3c-11.5 0-15.4 13.5-26.9 13.5h-.6v.8c0 9.4.6 18.1 1.8 26.2 10.6-.8 14.5-13.4 25.7-13.4 11.5 0 15.3 13.4 26.8 13.4 11.6 0 15.4-13.4 26.9-13.4 11.5 0 15.4 13.4 26.9 13.4 11.5 0 15.3-13.4 26.8-13.4 11 0 15 12.5 25.6 13.4a139 156.1 0 001.9-27h-.7c-11.5 0-15.3-13.4-26.8-13.4s-15.4 13.5-26.8 13.5c-11.5 0-15.4-13.5-27-13.5-11.4 0-15.3 13.5-26.8 13.5-11.4 0-15.3-13.5-26.8-13.5zm0 52.7c-9 0-13.2 8.2-20.2 11.8a111 124.5 0 008.6 20.5c3.3-2.8 6.7-5.2 11.6-5.2 11.5 0 15.3 13.5 26.8 13.5 11.6 0 15.4-13.5 26.9-13.5 11.5 0 15.4 13.5 26.8 13.5s15.4-13.5 26.9-13.5a18.3 20.6 0 0111.3 5 112 125.7 0 008.6-20.4c-6.7-3.7-11-11.7-20-11.7-11.4 0-15.3 13.5-26.8 13.5S491 267 479.6 267s-15.4 13.5-26.9 13.5c-11.4 0-15.3-13.5-26.8-13.5zm53.7 52.7c-11.5 0-15.4 13.5-26.9 13.5-10.9 0-14.9-12-25-13.4a132 132 0 0039.3 33c3.6-3.2 7.3 3.6 12.5 3.6 5.3 0 9-6.9 12.5-3.8a129.1 145 0 0039-32.7c-9.8 1.7-14 13.3-24.6 13.3-11.5 0-15.3-13.5-26.8-13.5z"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.86465 0 0 .97062 -175.4 2.5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M332.5 541.4a110 110 0 0110.5-3l16.3 15.7-13.4 2.7z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.6,
  d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3l6.7-31.1m-4.4 31.2l5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 014.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
  transform: "matrix(1.06 0 0 1.03 276.8 -178)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.4,
  d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 014.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
  transform: "matrix(-1.25 0 0 1.76 1290.4 -502)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 014.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
  transform: "matrix(-1.25 0 0 1.3 1321.3 -302)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M395.3 572.2l.9-73s2.6-.3 2.6 0-.3 72.7-.6 73c-.3.3-3.2.5-2.9 0zm28.5-69.8l-.6 61.3-2 2.4.6-63.7z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M363 560.2s3 30 36.4 29.1c33.4-.9 42.7-30.2 42.7-30.2l-14.5-.6c-.3 0-11.6 14-26.2 13.7-14.6-.3-19.2-3.8-22.4-6.7-3.2-3-6-7.3-6-7.3l-17-6.7 1 6.4zm90.3-3l-1-4v-3.4l1.6-3.6s-25.3 3.7-25.3 4l-.1 6.8 24.8.1z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M448.5 549.8l-.6 6h4.1l-.3-6zm-4.3.3l-.3 6.4 2.6-.3.3-6.1zm-4.4 6.4v-5l2.6-.9.3 5zm-5-.3l.6-4.4 3 .3.2 4.7zm-5.5 0l.3-3.8 3-.3v4.4zm-67.4 3.7c.9 0 7.6 1.5 7.6 1.5l7 9.3",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M366.8 561.1c.3.3 6.1 19.8 34 19.8s34.6-22.1 34.6-22.1",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M439.8 559.4s-13.4 29-39 27c-25.5-2-29.6-11.6-31.6-16.6-2-5-3.2-9-3.2-9",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M373.2 558.2c.3-1.7.3-54.4.3-54.4l-1.7-.2-.3 53.7 1.7 1zm-41.5-17.1l22 10.7-.5 1.5S332 543.3 332 543c0-.3.2-1.5-.3-2z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M341.8 537.9c0 .8 3.2 18.6 3.2 18.6s2 .3 2 0l-3.4-18.3zm20.4.5c1.1 0 21-3.2 21-3.2l-.4 3.2-19.5 2z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecf3e",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M365 514.3c.7 0 7 3.2 9.7 2.4 2.7-.8.9-3 1.4-3 .6 0 2.6 1.5 3.8.3 1.2-1.1 2-4.6 1.5-4.3-.6.3-16 5.8-16.3 4.6z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M362.5 521.6c1.1.3 23.8-6.1 23.8-6.1s0 2-.3 2l-23.5 6.1z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecf3e",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M415 512.6s1.5 3.5 3 2.9c1.5-.6 2.9-1.8 2.9-1.8s1.2 3 3.2 2.4c2-.6 3.2-3.8 3.2-3.8s2 .6 2.9.3c.9-.3 2-5 2-5l-17.1 5zm-1.7 28.2c-.3.6 1.5 2 3 2s2-2 2.3-1.4c.3.5.3 3.2 4 2.3 3.7-.9 3.8-3.5 3.8-3.5s-1.1.9 1.5 1.2c2.6.3 5.2-3.8 5-3.8-.4 0-19 3.5-19.6 3.2z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M363.4 513.1a5 5 0 00.2 2.7l19-6.4s.8-1.5 0-1.5-19.5 5.8-19.3 5.3zm25-4c.5 0 19.4-6.1 19.4-6.1s.3 2.6 0 2.6l-17.7 5.2-1.8-1.7z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecf3e",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M413.3 521.9s-2.9 3.2-2 7.5c.9 4.4 2 8.2 2.3 8.2.3 0 3.5-5.8 7-6.1 3.5-.3 9.9 3.2 9.9 3.2s-.9-7-.6-10.2c.3-3.2 5.2-8.7 5.2-8.7l-21.8 6z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M386.9 516.6s-.6 2.7-.3 2.7l24.7-6.4V511l-24.4 5.5z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b6b6b4",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M355.5 551.8s-5.8-.8-5.5.6c.3 1.5 2.9 2.9 3.2 3.8.3.9-.9 4 .9 3.8 1.7-.3 3.4-1.5 3.4-2.4l-.3-5z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M387.8 537.3v2l20.9-2.9-.6-1.5z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecf3e",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M363 540.8c.4 0 0 2.6 2.4 2 2.3-.6 2.9-2 2.9-2s.6 3.2 3.8 2.9c3.2-.3 5-3.8 5-3.8s.2 2.6 2.2 1.7c2-.9 2.6-2.9 2.6-2.9l-18.3 2.6-.5-.5zm0-17.2s-2.6.9-1.7 6.1c.9 5.2 3 8.2 3.2 8.2.3 0 2.6-5 6.1-5.8 3.5-1 9.6 2.6 9.6 2.6s-.6-4.7.3-9a18 18 0 013.8-7.6s-20.4 5.5-21.2 5.5z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M411.9 538.7l.3 1.8s21-2.6 21-3c0-.2 0-2-.4-2-.3 0-20.6 3.5-21 3.2zm-.3-18.6l.3 2 24.7-6.6s.6-1.8.3-1.8-24.7 7.3-25.3 6.4z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M414.2 510.8s-.3 1.8 0 1.8 18.3-4.4 18.3-4.7c0-.3 1.8-2 .3-1.7-1.4.3-18 5.5-18.6 4.6zm38.7 33.7l-18-28.4m-2.4 19.7c.3-.8 1.2-18.3 1.2-18.3",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fecf3e",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M389 510c1 .2 3.1 3.2 4.3 2.6 1.2-.6 2.9-2.4 2.9-2.4s-.3 3.5 2 3c2.4-.6 2.7-3 2.7-3s1.7 1 3.2 0c1.4-.8 2.8-5.2 2.3-5.2s-16.9 5.2-17.5 5zm-.6 8.4c0 .6-3 5.2-2 9.6 1 4.4 2.5 8.4 2.8 8.4.3 0 4.7-4.6 8.5-5.5 3.7-.9 9.3 2.9 9 2.9-.3 0-1.5-4.4-1.5-7.6 0-3.2 4.4-13 4.4-13zm0 21c0 .2.8 2.2 2.9 2.2 2 0 2.3-2 2.3-2s-.3 3.5 2.9 3.2c3.2-.3 4.3-3.5 4.3-3.5s.3 1.8 3 .9c2.6-.9 6-3.8 5.8-3.8-.3 0-21 3.8-21.3 3z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("use", {
  width: 992.1,
  height: 496.1,
  transform: "translate(-6.6 7.3)",
  xlinkHref: "#fk_svg__l"
}), /*#__PURE__*/React.createElement("use", {
  width: 992.1,
  height: 496.1,
  transform: "translate(6.6 3.8)",
  xlinkHref: "#fk_svg__l"
}), /*#__PURE__*/React.createElement("use", {
  width: 992.1,
  height: 496.1,
  transform: "translate(0 11)",
  xlinkHref: "#fk_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  id: "fk_svg__l",
  fill: "#be0f17",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.6,
  d: "M409 477a1.9 1.9 0 11-3.8 0 1.9 1.9 0 013.8 0z",
  transform: "matrix(.04 -1.07 1.02 .04 251.6 668)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M398.2 500c0-.2 9 3.8 9 4.1 0 .3 32 42.8 32.3 42.8m-16-42.8l8.2 3.5 2.6 6.4m-61.4-10.4c-.3 0 9 7 9 7l1.2 5.7M341.3 546c4-1.7 32.2-26.4 32.2-26.4m-39.8 21.7l31.7-26.7m21.2 4l30 49.8m-3.6-29.2s3.5 11.7 7 13.5a86 86 0 017.6 4.6",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M412.6 539.5s2.5 13.8 6 16.4c3.5 2.6 7 5.5 7 5.5",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M391 439s3.4 19.2 10.4 23.6a950 950 0 0112.8 8.1",
  transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M390.7 438.7s7.5 15.2 14 19.8c6.3 4.7 15 9 15 9M366.3 440c2 3.5 1.7 10.2 4 12.5a66 66 0 015.8 7.6m-9.3-19.9c1.2 1.7 4.4 10.4 6.4 13 1.5 2.4 16.3 17.2 16.3 17.2",
  transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M384.6 471.1a2.2 2.2 0 11-4.4 0 2.2 2.2 0 014.4 0zm10.7 4.7a1.9 1.9 0 11-3.8 0 1.9 1.9 0 013.8 0zM409 477a1.9 1.9 0 11-3.8 0 1.9 1.9 0 013.8 0zm11.9-4.5c0 1-.7 1.7-1.6 1.7-.9 0-1.6-.8-1.6-1.7 0-.9.7-1.8 1.6-1.8.9 0 1.6.8 1.6 1.8zm9.6-5.7c0 .9-.9 1.6-1.9 1.6-1 0-1.9-.7-1.9-1.6 0-.9.9-1.6 1.9-1.6 1 0 1.9.7 1.9 1.6z",
  transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M374.1 404.4c-.9.6-15.4 4.1-13.4 3.8 2-.3 13.7 3 13.4 2-.3-1 0-5.2 0-5.8zm24.7-4.3c-.6 0-9 3.2-8.7 3.2.3 0 9.6 2.6 9.3 2-.3-.6-.3-4.4-.6-5.2zm25.3 2.9c-.6.3-10.5 2.6-8.7 2.9 1.8.3 8.4 2.6 8.4 2 0-.5 0-4.6.3-5z",
  transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 014.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
  transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3l6.7-31.1m-4.4 31.2l5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 014.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
  transform: "matrix(1.25 0 0 1.36 225.3 -323.4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 014.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
  transform: "matrix(-1.25 0 0 1.32 1259.2 -307.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8b59",
  fillRule: "evenodd",
  stroke: "#512007",
  strokeWidth: 0.5,
  d: "M426.4 558.5l27.6.6.3-2-28.5-.3zm1.2-7.3c3.2 0 27.3-4.6 27.3-4.6s.9-3 0-3-27.3 5.6-27.3 5.6z",
  transform: "matrix(1.25 0 0 1.3 259.4 -430)"
}), /*#__PURE__*/React.createElement("use", {
  width: 992.1,
  height: 496.1,
  transform: "translate(0 5.5)",
  xlinkHref: "#fk_svg__l"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 0h320v240H0z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M37.5 0l122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M212 140.5L320 220v20l-135.5-99.5zm-92 10l3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M120.5 0v240h80V0zM0 80v80h320V80z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
});

var SvgFk = function SvgFk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

export default SvgFk;